const ANON_SESSION_KEY = 'anon.session-id'

const createSessionId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

/** Non-authenticating session correlation ID for public chat (X-Anon-Session). */
export const getAnonSessionId = (): string => {
  const existing = sessionStorage.getItem(ANON_SESSION_KEY)
  if (existing) {
    return existing
  }
  const next = createSessionId()
  sessionStorage.setItem(ANON_SESSION_KEY, next)
  return next
}
